import setupForm from './form-default.js'
import {addressAutocomplete} from './address.js'

// Attach the function to the window object
window.addressAutocomplete = addressAutocomplete
window.setupForm = setupForm
